export default __webpack_public_path__ + "static/media/Cyber-Risk-Assessment-and-Management.a9a7a5b1.svg";